import React from 'react';
import clsx from 'clsx';
import { useProgressLoader } from '../../headless';
import { RoundedProgressBar } from '../RoundedProgressBar';
import styles from './ProgressLoader.scss';
export function ProgressLoaderBar(_ref) {
  let {
    className,
    showPercentage = false,
    fillColor = '#000000',
    'aria-label': ariaLabel = 'Loading progress'
  } = _ref;
  const {
    progress
  } = useProgressLoader();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.progressWrapper, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: showPercentage ? styles.progressBarWithPercentage : undefined,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(RoundedProgressBar, {
    progress: progress,
    height: "8px",
    backgroundColor: "#e0e0e0",
    fillColor: fillColor,
    "aria-label": ariaLabel,
    className: styles.progressBar
  }), showPercentage && /*#__PURE__*/React.createElement("div", {
    className: styles.percentage
  }, Math.round(progress), "%")));
}
//# sourceMappingURL=ProgressLoaderBar.js.map